import { isObjectEmpty } from "./isObjectEmpty";
import { searchToObject } from "./searchToObject";

export const getFiltersFromLocation = () => {
  const currentSearch = searchToObject();
  if (isObjectEmpty(currentSearch.filters)) return false;
  return currentSearch.filters;
};
